<template>
  <svg viewBox="0 0 237 160" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_4389_70659)">
      <rect
        width="236.973"
        height="158.051"
        transform="translate(0.0273438 0.998291)"
        fill="#6A2F9D"
      />
      <path
        d="M61.6013 49.9987L64.1777 62.3737L51.2724 65.0605L48.696 52.6855L41.3152 54.2221L47.9218 85.9551L55.3026 84.4185L52.579 71.3364L65.4843 68.6495L68.2079 81.7317L75.5887 80.195L68.9821 48.4621L61.6013 49.9987ZM86.6518 78.3529C89.7013 77.718 91.8063 76.3114 93.0219 74.3983C94.6293 76.1387 97.5259 76.3195 101.454 74.81L100.368 69.5949C99.0349 70.0569 98.5193 69.7954 98.2709 68.6021L96.403 59.6302C95.2712 54.1941 90.9349 52.1918 84.8358 53.4616C78.9135 54.6946 75.9445 58.8172 75.7837 63.1391L82.7573 62.7478C82.8037 60.7554 83.6803 59.6506 85.7134 59.2273C88.0116 58.7489 89.1697 59.6605 89.5286 61.3842L89.6114 61.782L84.5803 63.7517C79.8217 65.4801 76.1605 68.2713 77.1634 73.0887C78.0192 77.199 81.967 79.3282 86.6518 78.3529ZM90.964 68.2788C91.4609 70.6654 89.5529 72.3538 87.2105 72.8415C85.531 73.1911 84.2605 72.6256 83.9569 71.1671C83.6164 69.5319 84.8577 68.6279 86.6495 67.932L90.5591 66.3342L90.964 68.2788ZM117.627 71.9502C124.035 70.616 126.518 64.3811 125.138 57.7517C123.749 51.0781 118.984 46.3522 112.575 47.6864C109.791 48.2661 107.82 49.8753 106.844 51.8308L106.356 49.4884L99.2849 50.9606L105.753 82.0306L112.825 80.5584L110.727 70.4816C112.393 71.8409 114.842 72.5299 117.627 71.9502ZM108.612 60.5467C107.876 57.011 109.372 54.6707 112.024 54.1186C115.117 53.4745 117.277 55.6532 118.022 59.2331C118.768 62.813 117.657 65.6727 114.563 66.3168C111.912 66.8688 109.597 65.2757 108.87 61.7842L108.612 60.5467ZM143.987 66.4621C150.396 65.1279 152.879 58.893 151.499 52.2636C150.109 45.5899 145.344 40.8641 138.936 42.1983C136.151 42.778 134.181 44.3872 133.205 46.3427L132.717 44.0003L125.646 45.4725L132.114 76.5425L139.186 75.0703L137.088 64.9935C138.754 66.3527 141.203 67.0418 143.987 66.4621ZM134.973 55.0585C134.237 51.5228 135.733 49.1825 138.384 48.6305C141.478 47.9864 143.638 50.1651 144.383 53.745C145.128 57.3249 144.018 60.1845 140.924 60.8286C138.272 61.3807 135.958 59.7875 135.231 56.296L134.973 55.0585ZM168.871 61.3275L172.795 35.6563L165.768 37.1193L164.064 52.4142L156.31 39.0884L149.017 40.6066L161.92 61.1609L161.658 62.7832C161.37 64.5031 160.525 65.0941 159.022 65.4069C158.315 65.5541 157.864 65.6019 157.227 65.6424L158.396 71.2553C159.21 71.1781 159.837 71.0935 161.075 70.8358C166.6 69.6856 168.123 66.3712 168.871 61.3275ZM49.4841 98.4864L52.0605 110.861L39.1551 113.548L36.5787 101.173L29.198 102.71L35.8046 134.443L43.1853 132.906L40.4617 119.824L53.367 117.137L56.0907 130.219L63.4714 128.683L56.8648 96.9497L49.4841 98.4864ZM87.4912 111.554C85.9822 104.306 80.1435 100.403 73.293 101.83C66.3984 103.265 62.6466 109.165 64.1556 116.413C65.6646 123.661 71.45 127.529 78.3446 126.093C85.195 124.667 89.0003 118.803 87.4912 111.554ZM71.1828 114.95C70.3363 110.884 71.6698 108.208 74.4984 107.619C77.327 107.03 79.6175 108.951 80.464 113.017C81.3105 117.084 79.977 119.759 77.1484 120.348C74.3198 120.937 72.0293 119.016 71.1828 114.95ZM93.2584 89.3728L86.187 90.845L92.7936 122.578L99.865 121.106L93.2584 89.3728ZM98.6579 94.566L105.862 93.0662L104.601 87.0113L97.3973 88.5111L98.6579 94.566ZM106.27 95.4712L99.199 96.9434L104.048 120.235L111.12 118.763L106.27 95.4712ZM124.199 116.547C126.983 115.967 128.954 114.358 129.939 112.447L130.418 114.745L137.489 113.273L130.883 81.5397L123.811 83.0119L126.056 93.7958C124.381 92.3924 121.932 91.7034 119.147 92.283C112.739 93.6172 110.256 99.8521 111.645 106.526C113.025 113.155 117.79 117.881 124.199 116.547ZM127.913 102.493L128.171 103.731C128.898 107.222 127.411 109.607 124.76 110.159C121.666 110.803 119.506 108.624 118.761 105.044C118.015 101.464 119.126 98.6048 122.22 97.9607C124.872 97.4086 127.177 98.9576 127.913 102.493ZM148.341 111.475C151.39 110.84 153.495 109.433 154.711 107.52C156.318 109.26 159.215 109.441 163.143 107.932L162.057 102.717C160.724 103.179 160.208 102.917 159.96 101.724L158.092 92.7519C156.96 87.3157 152.624 85.3135 146.525 86.5833C140.602 87.8163 137.633 91.9389 137.472 96.2608L144.446 95.8695C144.492 93.877 145.369 92.7723 147.402 92.349C149.7 91.8705 150.859 92.7822 151.217 94.5059L151.3 94.9036L146.269 96.8733C141.511 98.6018 137.849 101.393 138.852 106.21C139.708 110.321 143.656 112.45 148.341 111.475ZM152.653 101.401C153.15 103.787 151.242 105.475 148.899 105.963C147.22 106.313 145.949 105.747 145.646 104.289C145.305 102.654 146.546 101.75 148.338 101.054L152.248 99.4559L152.653 101.401ZM177.666 105.461L181.59 79.7901L174.563 81.2532L172.859 96.5481L165.105 83.2223L157.812 84.7405L170.714 105.295L170.453 106.917C170.165 108.637 169.32 109.228 167.817 109.541C167.11 109.688 166.659 109.736 166.022 109.776L167.19 115.389C168.004 115.312 168.632 115.227 169.87 114.97C175.394 113.82 176.918 110.505 177.666 105.461ZM184.649 99.9036C187.339 101.972 192.221 102.385 196.287 101.539C202.209 100.306 206.278 96.3691 205.219 91.2865C204.124 86.0271 199.228 85.986 194.855 86.0204C191.916 86.0789 190.509 86.1874 190.242 84.9057C190.021 83.845 190.988 82.952 192.712 82.5931C195.01 82.1146 197.52 82.6527 199.674 84.1409L202.262 78.8525C199.876 77.136 195.832 76.3178 191.633 77.192C185.888 78.3881 182.342 82.4002 183.327 87.1292C184.376 92.1676 188.698 92.3284 192.699 92.2792C196.55 92.1692 198.133 92.024 198.455 93.5708C198.713 94.8083 197.295 95.7491 195.439 96.1356C192.92 96.6601 189.657 96.0483 187.324 94.3667L184.649 99.9036Z"
        fill="white"
        fill-opacity="0.25"
      />
      <path
        d="M66.6053 47.6025L69.1816 59.9774L56.2763 62.6642L53.6999 50.2893L46.3191 51.8259L52.9257 83.5589L60.3065 82.0222L57.5829 68.9401L70.4882 66.2533L73.2119 79.3354L80.5926 77.7988L73.986 46.0658L66.6053 47.6025ZM91.6557 75.9566C94.7052 75.3217 96.8102 73.9151 98.0258 72.002C99.6332 73.7424 102.53 73.9233 106.458 72.4138L105.372 67.1986C104.039 67.6607 103.523 67.3991 103.275 66.2058L101.407 57.234C100.275 51.7978 95.9388 49.7956 89.8397 51.0654C83.9174 52.2983 80.9484 56.421 80.7876 60.7429L87.7613 60.3516C87.8076 58.3591 88.6842 57.2544 90.7173 56.8311C93.0155 56.3526 94.1736 57.2643 94.5325 58.988L94.6153 59.3857L89.5842 61.3554C84.8256 63.0839 81.1644 65.8751 82.1674 70.6925C83.0231 74.8027 86.9709 76.932 91.6557 75.9566ZM95.9679 65.8826C96.4648 68.2692 94.5568 69.9575 92.2144 70.4452C90.5349 70.7949 89.2644 70.2294 88.9608 68.7709C88.6203 67.1356 89.8616 66.2316 91.6534 65.5358L95.563 63.9379L95.9679 65.8826ZM122.631 69.554C129.039 68.2198 131.522 61.9849 130.142 55.3555C128.753 48.6818 123.988 43.956 117.579 45.2902C114.795 45.8699 112.824 47.479 111.848 49.4346L111.36 47.0921L104.289 48.5644L110.757 79.6344L117.829 78.1622L115.731 68.0854C117.397 69.4446 119.846 70.1337 122.631 69.554ZM113.616 58.1504C112.88 54.6147 114.376 52.2744 117.028 51.7223C120.121 51.0782 122.281 53.257 123.026 56.8369C123.772 60.4168 122.661 63.2764 119.567 63.9205C116.915 64.4726 114.601 62.8794 113.874 59.3879L113.616 58.1504ZM148.991 64.0658C155.4 62.7316 157.883 56.4968 156.503 49.8673C155.113 43.1937 150.348 38.4679 143.94 39.8021C141.155 40.3817 139.185 41.9909 138.209 43.9464L137.721 41.604L130.649 43.0762L137.118 74.1463L144.189 72.674L142.092 62.5973C143.758 63.9565 146.207 64.6455 148.991 64.0658ZM139.977 52.6623C139.241 49.1266 140.737 46.7863 143.388 46.2342C146.482 45.5901 148.642 47.7689 149.387 51.3488C150.132 54.9287 149.022 57.7883 145.928 58.4324C143.276 58.9845 140.962 57.3913 140.235 53.8998L139.977 52.6623ZM173.875 58.9313L177.799 33.26L170.772 34.723L169.068 50.018L161.314 36.6921L154.021 38.2104L166.924 58.7646L166.662 60.3869C166.374 62.1068 165.529 62.6978 164.026 63.0107C163.319 63.1579 162.868 63.2057 162.231 63.2461L163.4 68.8591C164.213 68.7818 164.841 68.6972 166.079 68.4396C171.603 67.2894 173.127 63.975 173.875 58.9313ZM54.488 96.0901L57.0644 108.465L44.159 111.152L41.5826 98.7769L34.2019 100.314L40.8085 132.047L48.1892 130.51L45.4656 117.428L58.371 114.741L61.0946 127.823L68.4754 126.286L61.8688 94.5535L54.488 96.0901ZM92.4951 109.158C90.9861 101.91 85.1474 98.0072 78.2969 99.4334C71.4023 100.869 67.6505 106.768 69.1595 114.017C70.6685 121.265 76.4539 125.133 83.3485 123.697C90.1989 122.271 94.0042 116.406 92.4951 109.158ZM76.1867 112.554C75.3402 108.487 76.6737 105.812 79.5023 105.223C82.3309 104.634 84.6214 106.555 85.4679 110.621C86.3145 114.687 84.9809 117.363 82.1523 117.952C79.3237 118.541 77.0332 116.62 76.1867 112.554ZM98.2623 86.9766L91.1909 88.4488L97.7975 120.182L104.869 118.71L98.2623 86.9766ZM103.662 92.1698L110.866 90.6699L109.605 84.615L102.401 86.1149L103.662 92.1698ZM111.274 93.0749L104.203 94.5472L109.052 117.839L116.123 116.366L111.274 93.0749ZM129.203 114.151C131.987 113.571 133.958 111.962 134.943 110.05L135.422 112.349L142.493 110.876L135.887 79.1434L128.815 80.6157L131.06 91.3996C129.385 89.9962 126.936 89.3071 124.151 89.8868C117.743 91.221 115.26 97.4559 116.649 104.13C118.029 110.759 122.794 115.485 129.203 114.151ZM132.917 100.097L133.175 101.335C133.902 104.826 132.415 107.211 129.764 107.763C126.67 108.407 124.51 106.228 123.765 102.648C123.019 99.0682 124.13 96.2085 127.224 95.5644C129.876 95.0124 132.181 96.5613 132.917 100.097ZM153.345 109.078C156.394 108.443 158.499 107.037 159.715 105.124C161.322 106.864 164.219 107.045 168.147 105.535L167.061 100.32C165.728 100.782 165.212 100.521 164.964 99.3275L163.096 90.3556C161.964 84.9195 157.628 82.9173 151.528 84.187C145.606 85.42 142.637 89.5427 142.476 93.8646L149.45 93.4733C149.496 91.4808 150.373 90.376 152.406 89.9528C154.704 89.4743 155.862 90.386 156.221 92.1096L156.304 92.5074L151.273 94.4771C146.514 96.2056 142.853 98.9968 143.856 103.814C144.712 107.924 148.66 110.054 153.345 109.078ZM157.657 99.0043C158.154 101.391 156.246 103.079 153.903 103.567C152.224 103.917 150.953 103.351 150.65 101.893C150.309 100.257 151.55 99.3533 153.342 98.6575L157.252 97.0596L157.657 99.0043ZM182.67 103.065L186.594 77.3939L179.567 78.8569L177.863 94.1519L170.109 80.826L162.816 82.3442L175.718 102.899L175.457 104.521C175.169 106.241 174.324 106.832 172.821 107.145C172.114 107.292 171.663 107.34 171.026 107.38L172.194 112.993C173.008 112.916 173.636 112.831 174.874 112.573C180.398 111.423 181.922 108.109 182.67 103.065ZM189.653 97.5074C192.343 99.5757 197.225 99.9888 201.291 99.1423C207.213 97.9093 211.281 93.9728 210.223 88.8903C209.128 83.6309 204.232 83.5897 199.858 83.6241C196.919 83.6827 195.513 83.7911 195.246 82.5094C195.025 81.4487 195.992 80.5557 197.715 80.1969C200.014 79.7184 202.523 80.2565 204.678 81.7446L207.266 76.4563C204.879 74.7397 200.836 73.9216 196.637 74.7957C190.892 75.9919 187.346 80.004 188.331 84.733C189.38 89.7714 193.702 89.9322 197.703 89.883C201.554 89.773 203.137 89.6277 203.459 91.1746C203.717 92.4121 202.299 93.3529 200.443 93.7394C197.923 94.2638 194.66 93.652 192.328 91.9705L189.653 97.5074Z"
        fill="white"
      />
      <ellipse
        cx="1.6929"
        cy="1.6929"
        rx="1.6929"
        ry="1.6929"
        transform="matrix(-1 0 0 1 34.1875 63.2549)"
        fill="#FFCD4B"
      />
      <ellipse
        cx="2.8215"
        cy="2.8215"
        rx="2.8215"
        ry="2.8215"
        transform="matrix(-1 0 0 1 95.125 30.5264)"
        fill="#288BFF"
      />
      <ellipse
        cx="2.8215"
        cy="2.8215"
        rx="2.8215"
        ry="2.8215"
        transform="matrix(-1 0 0 1 131.242 140)"
        fill="#288BFF"
      />
      <ellipse
        cx="124.3"
        cy="33.6875"
        rx="2.8215"
        ry="1.6929"
        transform="rotate(42.9246 124.3 33.6875)"
        fill="#FF814B"
      />
      <ellipse
        cx="92.7665"
        cy="138.364"
        rx="2.8215"
        ry="1.6929"
        transform="rotate(-30 92.7665 138.364)"
        fill="#FF814B"
      />
      <ellipse
        cx="212.415"
        cy="55.2514"
        rx="2.8215"
        ry="1.6929"
        transform="rotate(-30 212.415 55.2514)"
        fill="#4BC9FF"
      />
      <ellipse
        cx="26.8446"
        cy="133.794"
        rx="3.9501"
        ry="3.9501"
        fill="#FFCD4B"
      />
      <ellipse
        cx="151.001"
        cy="20.935"
        rx="3.9501"
        ry="3.9501"
        fill="#FFCD4B"
      />
      <ellipse
        cx="73.1226"
        cy="20.9317"
        rx="1.6929"
        ry="1.6929"
        fill="#4BFFBE"
      />
      <ellipse
        cx="173.568"
        cy="138.308"
        rx="2.8215"
        ry="2.8215"
        fill="#4BFFBE"
      />
      <ellipse
        cx="15.5676"
        cy="28.8337"
        rx="2.8215"
        ry="2.8215"
        fill="#4BFFBE"
      />
      <ellipse
        cx="187.103"
        cy="46.8896"
        rx="2.8215"
        ry="2.8215"
        fill="#DB4BFF"
      />
      <ellipse
        cx="43.7785"
        cy="34.4753"
        rx="2.8215"
        ry="2.8215"
        fill="#FF4B97"
      />
      <ellipse
        cx="209.116"
        cy="129.842"
        rx="3.3858"
        ry="3.3858"
        fill="#FF4B97"
      />
      <ellipse
        cx="202.904"
        cy="19.8064"
        rx="2.8215"
        ry="2.8215"
        fill="#FF4B97"
      />
      <ellipse
        cx="68.6067"
        cy="134.923"
        rx="2.8215"
        ry="2.8215"
        fill="#DB4BFF"
      />
      <ellipse
        cx="157.763"
        cy="117.993"
        rx="2.8215"
        ry="2.8215"
        fill="#DB4BFF"
      />
      <ellipse
        cx="184.853"
        cy="66.0769"
        rx="1.6929"
        ry="1.6929"
        fill="#FFFA8A"
      />
      <ellipse
        cx="104.72"
        cy="128.149"
        rx="1.6929"
        ry="1.6929"
        fill="#4BD4FF"
      />
    </g>
    <defs>
      <clipPath id="clip0_4389_70659">
        <rect
          width="236.973"
          height="158.051"
          fill="white"
          transform="translate(0.0273438 0.998291)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'HappyHolidays',
}
</script>
